import { useRemoteConfig } from "@shapr3d/frontend-lib";

import useAccount from "./useAccount";

const CHINA_EXPERIMENT_COUNTRIES: readonly string[] = ["CN", "HK"] as const;

export function useChinaUser() {
  const { data: accountData, isPending: isAccountPending } = useAccount();
  const paddleBillingFlag = useRemoteConfig("web_paddle_billing-cd");

  const isLoading =
    isAccountPending || accountData === undefined || paddleBillingFlag === undefined;
  const isPaddleBillingEnabled = paddleBillingFlag !== undefined && paddleBillingFlag !== "control";
  const isEligibleChinaUser =
    isPaddleBillingEnabled && CHINA_EXPERIMENT_COUNTRIES.includes(accountData?.countryCode ?? "");

  return {
    isChinaUser: isLoading ? undefined : isEligibleChinaUser,
    isLoading,
  };
}
